import { CameraEnhance, Upload } from '@mui/icons-material'
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom'
import { Box, Stack } from '@mui/material'
function DummyImageBoxWrapper({
  children,
  noBackground
}: {
  children: React.ReactNode
  noBackground?: boolean
}) {
  return (
    <Box
      sx={{
        width: '50%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      <Box
        sx={{
          border: noBackground ? undefined : '2px dashed grey',
          bgcolor: noBackground ? undefined : 'grey.200',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '300px',
          aspectRatio: '1 / 1',
          marginX: 'auto',
          boxSizing: 'border-box',
          cursor: 'pointer'
        }}
        component="label">
        {children}
      </Box>
    </Box>
  )
}
export const DummyImageBoxUI = ({
  isMobileDevice,
  children
}: {
  isMobileDevice: boolean | undefined
  children: React.ReactNode
}) => {
  return (
    <DummyImageBoxWrapper>
      {isMobileDevice ? <CameraEnhance /> : <Upload />}
      {children}
    </DummyImageBoxWrapper>
  )
}
export const ImageBoxUI = ({
  src,
  alt,
  readOnly,
  children
}: {
  src: string | undefined
  alt: string | undefined
  readOnly?: boolean
  children: React.ReactNode
}) => {
  if (src) {
    return (
      <Box
        sx={{
          width: '50%',
          height: '100%'
        }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}
          component={'label'}>
          <img
            src={src}
            alt={alt}
            style={{
              objectFit: 'contain',
              height: '100%',
              maxWidth: '100%',
              cursor: readOnly ? 'default' : 'pointer'
            }}
          />
          {children}
        </Box>
      </Box>
    )
  }
  return (
    <DummyImageBoxWrapper noBackground>
      <HourglassBottomIcon />
    </DummyImageBoxWrapper>
  )
}

export const CarouselSlides = ({ children }: { children: React.ReactNode }) => {
  return (
    <Stack spacing={1} direction="row" sx={{ width: '100%', height: '100%' }}>
      {children}
    </Stack>
  )
}
